import { c as _c } from "react/compiler-runtime";
import { DateFilterChip } from "@components/common/faro-table/faro-table-filter/date-filter/date-filter-chip";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { getMarkupsDueDateFilterOptions } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { TableType } from "@utils/track-event/track-event-list";

/** Show filters and apply them for project markup due date */
export function ProjectMarkupsDueDateFilter() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <DateFilterChip label={ProjectMarkupsTableHeaders.dueDate} filteredColumn={ProjectMarkupsTableHeaders.dueDate} presets={getMarkupsDueDateFilterOptions()} tableType={TableType.projectMarkups} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}